export default __webpack_public_path__ + "static/Plots0016-dc5ae9152c6ddcd5747b2d4aefa97ce3.jpg";